import React from 'react';
import { Link } from 'react-router-dom';

const Links = () => {
  return (
    <div className="flex flex-row justify-center gap-[26px] underline underline-offset-4 text-[14px] sm:text-[15px] md:text-[16px] md:font-normal leading-[18.81px]">
      <div>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
    </div>
  );
};

export default Links;
